// Used initially to update the displayed version number
// FIXED_TAB_COUNT represents the number of fixed tabs to left of tab area (before dynamic tabs for cases)
export const appConstants = {
    APPNAME: "Bideaze",
    FIXED_TAB_COUNT: 1,
    SHOW_WORKGROUP_BASKETS: false,
    DEFAULT_RIGHT_PANEL_SECTION: "pyCaseDetails"
};
